module.exports = __webpack_public_path__ + "media/application/images/external-services/square-logo-ca2b06bfc62329d163db71c0ed2d8b9f.svg";